import React, { useMemo, useState, useCallback, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Box, Typography } from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import { VideoFeedbackProvider } from './useVideoFeedback';
import { VideoFeedback } from './VideoFeedback';
import axiosInstant from '../../../../api';
import { getBrandProject } from '../../../../api/endpoints';

export interface VariationReviewModalProps {
  open: boolean;
  onClose: () => void;
  project: any;
  variationFile: any;
  onApproved?: () => void;
  readOnly?: boolean;
  title?: string;
}

export const VariationReviewModal: React.FC<VariationReviewModalProps> = ({
  open,
  onClose,
  project: propProject,
  variationFile,
  onApproved,
  readOnly = false,
  title = 'Variation Review'
}) => {
  const [fetchedProject, setFetchedProject] = useState<any>(null);

  useEffect(() => {
    // The lock (isReviewLocked) is derived from project.status, so a partial
    // project (video.project from the videos list) is not enough to trust.
    if ((propProject?.id && propProject?.status) || !open) return;
    const projectId = propProject?.id || variationFile?.projectId || variationFile?.project?.id;
    if (!projectId) return;
    axiosInstant.get(getBrandProject(projectId))
      .then((res) => setFetchedProject(res.data))
      .catch(() => {});
  }, [propProject, variationFile, open]);

  const project = fetchedProject || propProject;

  const scopedProject = useMemo(() => {
    if (!project) return { projectFiles: [variationFile] };
    return { ...project, projectFiles: [variationFile] };
  }, [project, variationFile]);

  const [confirmationData, setConfirmationData] = useState<any>();

  const handleApproved = useCallback(() => {
    if (onApproved) {
      onApproved();
    }
    onClose();
  }, [onApproved, onClose]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between" p={2}>
          <Typography variant="h4" fontWeight="bold">
            {title}
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <VideoFeedbackProvider
          project={scopedProject}
          video={variationFile}
          comments={[]}
          onApproved={handleApproved}
          onCloseReview={onClose}
          readOnly={readOnly}
        >
          <VideoFeedback
            confirmationData={confirmationData}
            onConfirmationClose={() => setConfirmationData(undefined)}
          />
        </VideoFeedbackProvider>
      </DialogContent>
    </Dialog>
  );
}; 